import * as WebBrowser from 'expo-web-browser';
import licenses from '@assets/licenses.json';
import React from 'react';
import { CONTAINER_MODAL_ROUTES } from '@/navigators/routes';
import { ContainerModalStackParams } from '@/navigators/types';
import { List } from '@/components/list';
import { ListOption } from '@/components/list-item';
import { ModalContainer } from '@/components/modal-container';
import { StackScreenProps } from '@react-navigation/stack';

interface Licenses {
  [packageName: string]: {
    licenses: string;
    licenseUrl?: string;
    parents: string;
    repository?: string;
  };
}

const typedLicenses = licenses as Licenses;

const packages = Object.keys(licenses).reduce((acc: ListOption[], pkg) => {
  const entry = typedLicenses[pkg];

  // if they don't have a license, assume they don't care
  if (entry.licenseUrl) {
    acc.push({
      subtitle: entry.licenses,
      title: pkg,
      value: entry.licenseUrl,
    });
  }
  return acc;
}, []);

type Props = StackScreenProps<
  ContainerModalStackParams,
  CONTAINER_MODAL_ROUTES.Licenses
>;

export const LicensesScreen: React.FC<Props> = () => {
  return (
    <ModalContainer>
      <List
        data={packages}
        keyExtractor={(option) => `${option.title}-${option.value}`}
        onSelect={(option) => WebBrowser.openBrowserAsync(String(option.value))}
      />
    </ModalContainer>
  );
};
